// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserInfo-module__user-info-container--Ywwai{display:flex;justify-content:flex-start;align-items:flex-start;width:250px}.UserInfo-module__name-and-role-container--fP_jv{display:flex;flex-direction:column;margin-left:10px;height:34px;line-height:16px}.UserInfo-module__display-name--fB2iZ{font-size:15px;font-weight:700;color:#373e44}.UserInfo-module__user-role--coP2U{margin-top:3px;font-size:13px;text-transform:capitalize}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"user-info-container": `UserInfo-module__user-info-container--Ywwai`,
	"userInfoContainer": `UserInfo-module__user-info-container--Ywwai`,
	"name-and-role-container": `UserInfo-module__name-and-role-container--fP_jv`,
	"nameAndRoleContainer": `UserInfo-module__name-and-role-container--fP_jv`,
	"display-name": `UserInfo-module__display-name--fB2iZ`,
	"displayName": `UserInfo-module__display-name--fB2iZ`,
	"user-role": `UserInfo-module__user-role--coP2U`,
	"userRole": `UserInfo-module__user-role--coP2U`
};
export default ___CSS_LOADER_EXPORT___;
